'use client'

import { Link } from '@repo/web-ui/components/link'
import { tw } from 'utils/classnames'
import { usePathname } from 'next/navigation'
import * as React from 'react'

import { HeaderSidebar } from './header'
import { useMyAccountNavigationSections } from '../../_hooks/use-my-account-navigation-sections'
import { LogoutItem } from './logout-item'
import { useModalContext } from '../../_context/modal-context'
import { useUsersBanStatusForCurrentUserQuery } from '@web/gen/user'
import { BanStatus } from 'codegen/types'

const sidebarItemClass = `hover:bg-cf-dreamy-cloud-300 flex w-full flex-row items-center justify-start rounded p-2 cursor-pointer text-[14px] font-medium leading-[16px] whitespace-normal [word-break:break-word]`

export function Sidebar() {
  const pathname = usePathname()
  const sections = useMyAccountNavigationSections()
  const { openOpenStoreModal } = useModalContext()
  const { data: isBanned, isLoading: isBannedLoading } = useUsersBanStatusForCurrentUserQuery(
    undefined,
    {
      select: data =>
        [BanStatus.UserBanStatusDesignerBlock].includes(
          data?.usersBanStatusForCurrentUser?.banStatus,
        ) || false,
    },
  )

  return (
    <aside
      id="sidebar"
      className="relative hidden w-64 shrink-0 flex-col self-stretch overflow-hidden md:flex  "
    >
      <section className="bg-cf-white rounded-t-2 w-full  overflow-hidden border-x border-t border-[#DADCE2] pb-4">
        <HeaderSidebar />
      </section>
      <section className="bg-cf-white rounded-b-2 w-full border border-[#DADCE2]">
        <div className="text-cf-sf-gray-1100 flex w-full flex-col justify-start px-4 pb-7">
          {sections.map(section => (
            <div key={section.title}>
              <p className="text-12 mt-4 py-1 pl-2.5 font-normal " key={section.title}>
                {section.title}
              </p>
              <div className="flex flex-col gap-0.5">
                {section.items.map(item => {
                  const Icon = item.icon

                  // Handle special open-store path
                  if (item.path === '/open-store') {
                    if (isBanned || isBannedLoading) {
                      return null
                    }
                    return (
                      // oxlint-disable-next-line react/button-has-type
                      <button
                        key={item.title}
                        className={tw(sidebarItemClass)}
                        onClick={openOpenStoreModal}
                      >
                        {<Icon className="mr-2 size-4 " />}
                        {item.title}
                      </button>
                    )
                  }

                  return (
                    <Link
                      key={item.title}
                      className={tw(
                        pathname === item.path + '/' ? 'bg-cf-sf-gray-150' : '',
                        sidebarItemClass,
                      )}
                      href={item.path}
                    >
                      {<Icon className="mr-2 size-4 shrink-0" />}
                      {item.title}
                    </Link>
                  )
                })}
              </div>
            </div>
          ))}
          <LogoutItem className={tw('hover:bg-cf-sf-gray-150', sidebarItemClass)} />
        </div>
      </section>
    </aside>
  )
}
